import { useEffect } from 'react'
import { getCustomerName, getShopId, queryClient, useTranslate } from 'utils'
import { useField } from 'react-final-form'
import { FormRemove } from 'components/form-remove/form-remove'
import { useNavigate } from 'react-router-dom'
import { useRemoveCustomer } from 'api'
import { message } from 'antd'
import { Customer } from 'types'

export const CustomerRemove = () => {

    //hooks:
    const { __ } = useTranslate()
    const navigate = useNavigate()
    const { input: { value: id } } = useField('id')
    const { input: { value: firstName } } = useField('firstName')
    const { input: { value: lastName } } = useField('lastName')
    const { input: { value: email } } = useField('email')
    const { input: { value: phone } } = useField('phone')

    //api:
    const { mutate, isLoading, data: response } = useRemoveCustomer(id)

    //after remove:
    useEffect(() => {
        if(response === true){
            queryClient.invalidateQueries(['customers', getShopId()])
            message.success(__`customer_removed`)
            navigate('/customer')
        }else if(response === false){
            message.error(__`cant_remove_customer`)
        }
    }, [response])

    const customer: Customer = {
        id: '',
        firstName,
        lastName,
        email,
        phone,
        image: {
            id: null,
            path: null
        },
        description: null,
        externalId: null,
        externalSource: null
    }
    
    return (
        <FormRemove
            title={`${__`remove`} "${getCustomerName(customer)}"`}
            message={__`all_settings_will_be_deleted_this_action_cant_be_undone`}
            description={__`this_will_not_effect_on_on_previous_appointments`}
            isLoading={isLoading}
            onRemove={mutate}
        />
    )

}
